export default "data:image/png;base64,UklGRkIAAABXRUJQVlA4TDYAAAAvBAABEFcw//M//0QCpEEn0DQywUAOgBBHMQgA1AQAwRgFhKCgGE6nADNxRP9DFLKwnzvADQA="